module.exports = __webpack_public_path__ + "static/media/9010_7035.b26c8b7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/9010_7035.jpg
// module id = 85
// module chunks = 0